import { EcomFilter2 } from '@obvio/template'

import { LightModal } from './FiltersModal/components'
import { FadeIn } from '../FadeIn'

import type { ReactElement } from 'react'

type FiltersModalProps = {
  open: boolean
  onClose(): void
}

export function FiltersModal({
  open,
  onClose,
}: FiltersModalProps): ReactElement {
  return (
    <LightModal open={open} onClose={onClose}>
      <FadeIn>
        <EcomFilter2 onSubmit={onClose} onClear={onClose} />
      </FadeIn>
    </LightModal>
  )
}
